export default async function dyLoaded() {
  return new Promise((resolve) => {
    let dyLoadedChecker;
    function checker() {
      if (window.DY && window.DY.API && window.DYO) {
        window.cancelAnimationFrame(dyLoadedChecker);
        dyLoadedChecker = undefined;
        resolve();
      } else {
        dyLoadedChecker = window.requestAnimationFrame(() => {
          checker();
        });
      }
    }

    checker();
  });
}
